module.exports = __webpack_public_path__ + "pc/img/ico-x.7ccafbc5.svg";